(function() {
    'use strict';

    function openModalWithUrl(trigger, loginModal, targetUrl) {
        let loginModalIframe = document.getElementById('login-iframe');
        if (!loginModalIframe) {
            loginModalIframe = document.createElement('iframe');
            loginModalIframe.id = 'login-iframe';
            loginModalIframe.title = loginModal.dataset.iframeTitle;
            loginModal.appendChild(loginModalIframe);
        }
    
        trigger.loading = true;

        const finish = () => {
            trigger.loading = false;
            loginModal.show();
        };

        if (loginModalIframe.dataset.loadedUrl === targetUrl) {
            finish();
            return;
        }

        const controller = new AbortController();
        loginModalIframe.addEventListener('load', () => {
            loginModalIframe.dataset.loadedUrl = targetUrl;
            finish();
            controller.abort();
        }, { signal: controller.signal });

        try {
            loginModalIframe.src = targetUrl;
        } catch (_) {
            trigger.loading = false;
        }
    }

    function init() {
        const loggedInElements = document.querySelectorAll('.user-controls .logged-in');
        const loggedOutElements = document.querySelectorAll('.user-controls .logged-out');
        const userNameElements = document.querySelectorAll('.user-name');
        const userIconElements = document.querySelectorAll('.user-icon');
        const user = window.TNCMS?.User;

        if (user && user.isLoggedIn()) {
            const firstName = user.getFirstName();
            const lastName = user.getLastName();
            const screenName = user.getScreenName();
            const avatarUrl = user.getAvatarURL();

            loggedInElements.forEach((el) => { el.style.display = 'block'; });
            loggedOutElements.forEach((el) => { el.style.display = 'none'; });

            if (firstName) {
                let fullName = firstName;

                if (lastName) {
                    fullName += " " + lastName;
                };

                userNameElements.forEach((el) => {
                    el.textContent = fullName;
                });

            } else if (screenName) {
                userNameElements.forEach((el) => {
                    el.textContent = screenName;
                });
            };

            if (avatarUrl) {
                userIconElements.forEach((el) => {
                    const img = document.createElement('img');
                    img.alt = 'user-icon';

                    try {
                        const parsed = new URL(avatarUrl, window.location.origin);
                        if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
                            img.src = parsed.href;
                            el.replaceChildren(img);
                        }
                    } catch (_) {
                        console.warn('Invalid avatar URL');
                    }
                });
            };
        } else {
            loggedInElements.forEach((el) => { el.style.display = 'none'; });
            loggedOutElements.forEach((el) => { el.style.display = 'block'; });
        };

        // login button opens modal and initializes iframe
        const loginModal = document.getElementById('login-modal');

        if (loginModal) {
            document.addEventListener('click', function(e) {
                const loginBtn = e.target.closest('[data-open-login-modal]');
                const signupBtn = e.target.closest('[data-open-signup-modal]');

                if (loginBtn) {
                    openModalWithUrl(loginBtn, loginModal, loginModal.dataset.loginUrl);
                } else if (signupBtn) {
                    openModalWithUrl(signupBtn, loginModal, loginModal.dataset.signupUrl);
                }
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

window.addEventListener('message', (e) => {
    if (e.origin !== window.location.origin) return;

    if (e.data === 'login-success') {
        window.location.reload();
        return;
    }

    if (e.data && typeof e.data === 'object' && e.data.type === 'admin-login-attempt' && e.data.url) {
        window.location.href = e.data.url;
    };
});